<ng-container *ngrxLet="data$; let data" [atxAngularReactive]="[data$]">
  @if (data.isAdvancedMdo) {
  <epc-advanced-size-grid
    [shipTos]="data.deliveryShops"
    [products]="data.materials"
    [scaleSets]="data.scaleSets"
    [availableScaleSets]="data.availableScaleSets"
    [selectedScale]="data.selectedScale"
    [deliveryItems]="data.allDeliveryItems"
    [sizesInventories]="data.sizesInventories"
    [titleAttributes]="data.materialTitleAttributes"
    [disabledMaterialsIds]="data.disabledIds"
    [isNowOrder]="data.isNowOrder"
    [portable]="compactMdo"
    [shopTotals]="data.shopTotals"
    [skipInventoryCheck]="data.skipInventoryCheck"
    [differentMaterialDimensions]="data.differentMaterialDimensions"
    [productImageMissingVisualConfig]="productImageMissingVisualConfig$ | async"
    (quantityChanged)="quantityChanged($event)"
    (cellCleared)="clearSizeMdoCell($event)"
    (copyQuantities)="copyQuantities($event, data.materials)"
    (sizeSelect)="setActiveSize($event)"
    (variantSelected)="selectVariant($event)"
    (clearShop)="clearShop($event)"
    (shopSelect)="selectShop($event)"
  ></epc-advanced-size-grid>
  } @if ( data.availableScaleSets && data.isSizeGridVisible &&
  !data.isScaleSetInvalid && !data.isAdvancedMdo ) { @if (data.useVerticalGrid
  === false) {
  <epc-size-grid
    class="mb-1"
    [availableScaleSets]="data.availableScaleSets"
    [basketData$]="basketData$"
    [cellsQuantities]="data.selectCellsQuantities"
    [dabsData]="data.dabsData"
    [deliveryItems]="data.deliveryItems"
    [deliveryShop]="data.activeDeliveryShop"
    [deliveryWindowType]="data.deliveryWindowType"
    [differentMaterialDimensions]="data.differentMaterialDimensions"
    [disabledMaterialsIds]="data.disabledIds"
    [editCustomerProductIdentifierEnabled]="data.productExtensionsLoaded"
    [isCopyPrefilledVisible]="data.isCopyToMasterQuantityPrefilledVisible"
    [isNowOrder]="data.isNowOrder"
    [materials]="data.materials"
    [materialsPrices]="data.materialsPrices"
    [preSelectedMaterial]="data.selectedVariantId"
    [productExtensions]="data.productExtensions"
    [productImageMissingVisualConfig]="productImageMissingVisualConfig$ | async"
    [scaleDisplayObject]="data.scaleDisplayObject"
    [scaleSets]="data.scaleSets"
    [selectedScale]="data.selectedScale"
    [showGridInbound]="data.showGridInbound"
    [showNextAvailableDate]="data.showNextAvailableDate"
    [sizerunsGrid]="data.sizerunsGrid"
    [sizeRunsSizes]="data.sizeRunsSizes"
    [sizesInventories]="data.sizesInventories"
    [skipInventoryCheck]="data.skipInventoryCheck"
    [titleAttributes]="data.materialTitleAttributes"
    [showInventoryOverview]="!data.hideInventoryOverviews"
    [isScaleSelectorDisabled]="data.hasLockSizeRunSelector"
    epcGridNavigation
    rowSelector="[navRow]"
    cellSelector="[navCell]"
    disabledSelector="navDisabled"
    (sizeSelect)="setActiveSize($event)"
    (quantityChange)="quantityChanged({ changes: $event })"
    (masterQuantitiesPrefill)="masterQuantitiesPrefill($event)"
    (scaleSelected)="handleScaleSelection($event)"
    (periodSelected)="handlePeriodChange($event)"
    (customerProductIdentifierUpdate)="updateCustomerProductIdentifier($event)"
    data-e2e="size-grid"
  ></epc-size-grid>
  } @else {
  <!-- Should find a better way to not duplicate properties -->
  <epc-vertical-size-grid
    [availableScaleSets]="data.availableScaleSets"
    [deliveryItems]="data.deliveryItems"
    [deliveryShop]="data.activeDeliveryShop"
    [deliveryWindowType]="data.deliveryWindowType"
    [differentMaterialDimensions]="data.differentMaterialDimensions"
    [disabledMaterialsIds]="data.disabledIds"
    [isCopyPrefilledVisible]="data.isCopyToMasterQuantityPrefilledVisible"
    [isNowOrder]="data.isNowOrder"
    [materials]="data.materials"
    [materialsPrices]="data.materialsPrices"
    [preSelectedMaterial]="data.selectedVariantId"
    [productExtensions]="data.productExtensions"
    [productImageMissingVisualConfig]="productImageMissingVisualConfig$ | async"
    [scaleDisplayObject]="data.scaleDisplayObject"
    [selectedScale]="data.selectedScale"
    [scaleSets]="data.scaleSets"
    [isScaleSelectorDisabled]="data.hasLockSizeRunSelector"
    [showNextAvailableDate]="data.showNextAvailableDate"
    [sizerunsGrid]="data.sizerunsGrid"
    [sizeRunsSizes]="data.sizeRunsSizes"
    [sizesInventories]="data.sizesInventories"
    [skipInventoryCheck]="data.skipInventoryCheck"
    [titleAttributes]="data.materialTitleAttributes"
    [showInventoryOverview]="!data.hideInventoryOverviews"
    rowSelector="[navRow]"
    cellSelector="[navCell]"
    (sizeSelect)="setActiveSize($event)"
    (quantityChange)="quantityChanged({ changes: $event })"
    (periodSelected)="handlePeriodChange($event)"
    data-e2e="size-grid"
  ></epc-vertical-size-grid>
  } } @if (data.isScaleSetInvalid) {
  <atx-no-data-panel class="border-top border-bottom d-block pt-3"
    ><h1
      i18n="
        Config Strip|A text to show when the scale sets for the grid don't have
        a good structure@@isScaleSetInvalids"
    >
      Unable to show the sizes grid, scale sets information is corrupt
    </h1></atx-no-data-panel
  >
  }
</ng-container>
